module.exports = __webpack_public_path__ + "img/voicemail.17e22cc2.svg";